import { FunctionComponent } from 'react';
import LinkIcon from '@mui/icons-material/LinkOutlined';
import CopyIcon from '../../../../../../assets/icons/copy.svg';
import l from '../../../../../../lang';
import Input from '../../../../../common/input';
import ButtonCustom from '../../../../../common/__deprecated__/button-custom';
import CopyToClipboard from 'react-copy-to-clipboard';
import ShareButtons from '../../../share-buttons';
import { Urls } from '../../../../../../config/urls';
import Dialog from '../../../../../common/dialog';
import { useMediaQuery } from '@mui/material';
import './styles.scss';

interface PaymentLinkDialogProps {
  url: string;
  country: string;
  currency: string;
  amount: number;
  description: string;
  onClose: () => void;
}

const PaymentLinkDialog: FunctionComponent<PaymentLinkDialogProps> = ({
  url,
  country,
  currency,
  amount,
  description,
  onClose,
}) => {
  const isTabletMobile = useMediaQuery('(max-width:768px)');

  const descriptionBox = (
    <div className="payment_link_dialog__share__card">
      <div className="payment_link_dialog__share__card__headline">{l('paymentLink.shareLink.field3')}</div>
      <div className="payment_link_dialog__share__card__content">{description || ' - '}</div>
    </div>
  );

  return (
    <Dialog
      dividers={false}
      title={<p className="payment_link_dialog__share__headline">{l('paymentLink.shareLink.headline')}</p>}
      unpaddingFooter
      fullScreenMobile
      handleClose={onClose}
      type="sm"
      body={
        <div className="payment_link_dialog__share">
          <div className="payment_link_dialog__share__wrapper">
            <div className="payment_link_dialog__share__cards">
              <div className="payment_link_dialog__share__card">
                <div className="payment_link_dialog__share__card__headline">{l('paymentLink.shareLink.field1')}</div>
                <div className="payment_link_dialog__share__card__content">
                  <div className="payment_link_dialog__share__card__country">
                    <img alt="" src={`${Urls.flags.replace(':code', country)}`} />
                    <span>{l(`countryCode.${country}`)}</span>
                  </div>
                </div>
              </div>
              <div className="vertical_line" />
              <div className="payment_link_dialog__share__card">
                <div className="payment_link_dialog__share__card__headline">{l('paymentLink.shareLink.field2')}</div>
                <div className="payment_link_dialog__share__card__content">
                  {currency} {amount}
                </div>
              </div>
              {!isTabletMobile && (
                <>
                  <div className="vertical_line" />
                  {descriptionBox}
                </>
              )}
            </div>
            {isTabletMobile && <>{descriptionBox}</>}
          </div>
          <div className="payment_link_dialog__share__subheadline">{l('paymentLink.shareLink.subheadline1')}</div>
          <div className="payment_link_dialog__share__link">
            <div className="input">
              <Input name="copyLink" value={url} prefix={<LinkIcon color="primary" />} readOnly disabled />
            </div>
            <CopyToClipboard text={url}>
              <ButtonCustom
                name="btn-confirm"
                text={l('paymentLink.shareLink.copyLink')}
                color="primary"
                variant="contained"
                startIcon={<img className="payment_link_dialog__share__img_copy" src={CopyIcon} />}
              />
            </CopyToClipboard>
          </div>
          <ShareButtons link={url} />
        </div>
      }
      footer={<div className="payment_link_dialog__share__footer" />}
    />
  );
};

export default PaymentLinkDialog;
